// version 2.4 - hvs
window.__cordova_init = false
window.__cordova_platform = ''
window.__backkey_func = ''
window.__cordova_init_finish = null
window.__m_use_top_bar = false
window.__m_top_bar_fix = false
window.__mocean_util = ''


var __cordova_path = ''

let __m_ev = ''
let __m_url = ''



var __m_moceanready = new CustomEvent("moceanready")


export var hdxCordova = function (options) {
  if (options.prod_url) {
    __m_url = options.prod_url
  }
  if (options.use_top_bar) {
    window.__m_use_top_bar = options.use_top_bar
  }
  if (options.top_bar_fix) {
    window.__m_top_bar_fix = options.top_bar_fix
  }
  if (
      window.location.hostname === __m_url
  ) {
    console.log('운영 도메인')
    __m_ev = 'prod'
  } else {
    console.log('개발 도메인')
    __m_ev = 'dev'
  }

  var __m_cordova_type = ''


  if (navigator.userAgent.indexOf('androidCordova') > 0) {
    __m_cordova_type = 'androidCordova'
  } else if (navigator.userAgent.indexOf('iosCordova') > 0) {
    __m_cordova_type = 'iosCordova'
  } else {
    __m_cordova_type = 'browser'
  }
  console.log('hdx util 준비')  
  

  if (__m_cordova_type === 'androidCordova') {
    console.log('안드로이드 진입')
    if (__m_ev === 'dev') {
      __cordova_path = 'https://mocean.hd-hvs.com/mlauncher/external/mocean/android/'
    } else {
      __cordova_path = 'https://mocean.hd-hvs.com/mlauncher/external/mocean/android/'
    }
    window.__cordova_platform = 'android'
  } else if (__m_cordova_type === 'iosCordova') {
    if (__m_ev === 'dev') {
      __cordova_path = 'https://mocean.hd-hvs.com/mlauncher/external/mocean/ios/'
    } else {
      __cordova_path = 'https://mocean.hd-hvs.com/mlauncher/external/mocean/ios/'
    }
    window.__cordova_platform = 'ios'
  } else {
    if (__m_ev === 'dev') {
      __cordova_path = 'https://mocean.hd-hvs.com/mlauncher/external/mocean/browser/'
    } else {
      __cordova_path = 'https://mocean.hd-hvs.com/mlauncher/external/mocean/browser/'
    }
    window.__cordova_platform = 'browser'
  }

  function _includeJs(jsFilePath) {
    var js = document.createElement('script')
    js.type = "text/javascript"
    js.src = jsFilePath

    document.head.appendChild(js)
  }
  _includeJs(__cordova_path + 'cordova.js' )
  document.addEventListener('deviceready', __onDeviceReady, false)
}


function __onDeviceReady() {
  console.log('Running cordova-' + cordova.platformId + '@' + cordova.version)
  window.__cordova_init = true
  NativeStorage.initWithSuiteName("suitename")
  if (window.__m_use_top_bar === true) {
    let __m_cordovaTitle = ''

    function __m_onSuccess(title) {
      __m_cordovaTitle = title
      console.log('타이틀 가져오기 성공', title)
      try {
        if (__m_cordovaTitle) {
          function __m_exit() {
            if (navigator.userAgent.indexOf('iosCordova') > 0) {
              webview.Hide()
            } else if (navigator.userAgent.indexOf('androidCordova') > 0) {
              webview.ExitApp()
            }

            function __m_setTitleSuccess(message) {
              console.log(message, '앱 종료시 타이틀 set 성공')
            }

            function __m_setTitleFail(message) {
              console.log(message, '앱 종료시 타이틀 set 실패')
            }

            NativeStorage.setItem("cordova_title", '빈제목', __m_setTitleSuccess, __m_setTitleFail)

          }
          var oDivMain = document.createElement('div')
          var oDivSub = document.createElement('div')
          var oDivLeft = document.createElement('div')
          var oDivRight = document.createElement('div')
          var oSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')


          if (window.__m_top_bar_fix) {
            oDivMain.setAttribute('style', 'position:sticky; top:0; width:100%; z-index: 100000;')
          }
          oDivSub.setAttribute('style', 'background:rgb(var(--v-theme-surface));width:100%;padding-top:1%;padding-bottom:1%;display:flex;')
          oDivLeft.setAttribute('style', 'flex: 100%;text-align: center;align-self: center;')

          var oSpan = document.createElement('span')
          oSpan.setAttribute('style', 'font-size:0.875rem !important;font-weight:500;line-height: 1.375rem;letter-spacing: 0.0071428571em !important;font-family: "Roboto", sans-serif !important;text-transform: none !important;')
          oSpan.innerText = __m_cordovaTitle

          oDivLeft.appendChild(oSpan)

          oSvg.addEventListener('click', __m_exit)
          oSvg.setAttribute('viewBox', '0 0 24 24')
          oSvg.setAttribute('style', 'width: 45px; height: 25px')
          oSvg.innerHTML = `<title>close</title><path fill="currentColor" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" /></svg>`

          oDivRight.setAttribute('style', 'position: absolute;right: 0;')


          oDivRight.prepend(oSvg)
          oDivSub.appendChild(oDivLeft)
          oDivSub.appendChild(oDivRight)

          var oHr = document.createElement('hr')
          oHr.className = 'v-divider'

          oDivMain.appendChild(oDivSub)
          oDivMain.appendChild(oHr)

          document.body.prepend(oDivMain)
          console.log(window.__cordova_init_finish, 'init finish before')
          console.log(typeof window.__cordova_init_finish, 'init type')
          if (typeof window.__cordova_init_finish === 'function') {

            console.log(window.__cordova_init_finish, 'init finish in')
            window.__cordova_init_finish()
          }


          window.dispatchEvent(__m_moceanready);
          console.log(window.__cordova_init_finish, 'init finish after')
          //return;
        }

      } catch (err) {
        console.log(err, '상단 바 만들기 실패')
      }
      console.log('타이틀 set 성공=== try 마지막')
      return
    }

    function __m_onFail(message) {
      console.log(message, '타이틀 set 실패')
    }

    console.log('로컬스토리지 타이틀', __m_cordovaTitle)
    NativeStorage.getItem('cordova_title', __m_onSuccess, __m_onFail)
  } else {
    // setIosJS()
    window.dispatchEvent(__m_moceanready);
  }
}

// mocean.js의 api를 사용 할 때 String과 Function 타입의 콜백함수 1개를 넘겼을때 function 을 호출하도록 변환해주는 함수
// 터치원에서 mocean으로 이관 시 기존 터치원에서 String타입으로 콜백함수 명을 넘겨주던 로직을 대비
function oneFuncTranslator (func) {
  return new Promise((resolve, reject) => {
    let exefunc = ''
    if (typeof (func) !== "function") {
      try {
        exefunc = eval(func)
      } catch(e)
      {
        alert(func + ' 는 Function이 아닙니다.')
        return
      }
    } else
    {
      exefunc = func // function 타입으로 넘겼을경우
    }
      resolve({callback: exefunc})
  })
}

// mocean.js의 api를 사용 할 때 String과 Function 타입의 콜백함수 2개를 넘겼을때 function 을 호출하도록 변환해주는 함수
// 터치원에서 mocean으로 이관 시 기존 터치원에서 String타입으로 콜백함수 명을 넘겨주던 로직을 대비
function twoFuncTranslator (func1, func2) {
  return new Promise((resolve, reject) => {
    let exefunc1 = ''
    let exefunc2 = ''
    if (typeof (func1) !== "function") {
      try {
        exefunc1 = eval(func1)
      } catch(e)
      {
        alert(func1 + ' 는 Function이 아닙니다.')
        return
      }
    } else
    {
      exefunc1 = func1 // function 타입으로 넘겼을경우
    }
    if (typeof (func2) !== 'function') {
      try {
        exefunc2 = eval(func2)
      } catch(e)
      {
        alert(func2 + ' 는 Function이 아닙니다.')
        return
      }
    } else
    {
      exefunc2 = func2 // function 타입으로 넘겼을경우
    }
      resolve({successCallback: exefunc1, failCallback: exefunc2})
  })
 }
  hdxCordova.prototype = {
    executeCamera: function (successcallback, userSpec, option, failcallback) {
      let defaultoption = Camera.DestinationType.FILE_URI
      if (option === 0) {
        defaultoption = option
      }
      twoFuncTranslator(successcallback, failcallback).then(res => {
        function tempcallback(data) {
          res.successCallback(userSpec, data)
        }
        if (navigator.userAgent.indexOf('androidCordova') > 0) {
          navigator.camera.getPicture(tempcallback, res.failCallback, {
            quality: 100,
            destinationType: defaultoption,
            correctOrientation: true,
          })
        } else if (navigator.userAgent.indexOf('iosCordova') > 0) {
          navigator.camera.getPicture(tempcallback, res.failCallback, {
            sourceType: Camera.PictureSourceType.CAMERA,
            destinationType: defaultoption,
            quality: 50,
            correctOrientation: true,
            mediaType: Camera.MediaType.PICTURE,
            targetHeight: 300,
            targetWidth: 400,
          })
        } else {
          console.log('browser not support')
        }
      })
    },
    executeCameraAlbum: function (successcallback, userSpec, option, failcallback) {
      let defaultoption = Camera.DestinationType.FILE_URI
      if (option === 0) {
        defaultoption = option
      }
      if (navigator.userAgent.indexOf('androidCordova') > 0) {
        navigator.camera.getPicture(successcallback, failcallback, {
          destinationType: defaultoption,
          sourceType: Camera.PictureSourceType.SAVEDPHOTOALBUM,
        })
      } else if (navigator.userAgent.indexOf('iosCordova') > 0) {
        navigator.camera.getPicture(successcallback, failcallback, {
          destinationType: defaultoption,
          sourceType: Camera.PictureSourceType.PHOTOLIBRARY,
          popoverOptions: new CameraPopoverOptions(300, 300, 100, 100, Camera.PopoverArrowDirection.ARROW_ANY, 300, 600),

        })
      } else {
        console.log('browser not support')
      }
    },
    executeBleScan: function (successcallback, userSpec, option, failcallback) {
      if (navigator.userAgent.indexOf('androidCordova') > 0) {
        ble.startScan([], successcallback, failcallback)
      } else if (navigator.userAgent.indexOf('iosCordova') > 0) {
        ble.startScan([], successcallback, failcallback)
      } else {
        console.log('browser not support')
      }
    },
    executeBleStopScan: function (successcallback, userSpec, option) {
      if (navigator.userAgent.indexOf('androidCordova') > 0) {
        ble.stopScan
      } else if (navigator.userAgent.indexOf('iosCordova') > 0) {
        ble.stopScan
      } else {
        console.log('browser not support')
      }
    },
    executeNfc: function (successcallback, userSpec, option) {
      if (navigator.userAgent.indexOf('androidCordova') > 0 || navigator.userAgent.indexOf('iosCordova') > 0) {
        function checkingNfc(nfcEvent) {

          // nfc.addNdefListener(callback, [onSuccess], [onFailure]);
          //   callback : NDEF 태그를 읽을 때 호출되는 콜백입니다.
          //   onSuccess : (선택 사항) 수신기가 추가될 때 호출되는 콜백입니다.
          //   onFailure : (선택 사항) 오류가 발생한 경우 호출되는 콜백입니다.

          var message = [
            ndef.textRecord(new String(new Date())),
          ]

          nfc.write(
              message,
              success => console.log('wrote data to tag'),
              error => console.log(error)
          )
        }

        function onSuccess(message) {
          alert('Success because: ' + message)
        }

        function onFail(message) {
          console.log(message)
          alert('Failed because: ' + message)
        }

        nfc.addNdefListener(checkingNfc, onSuccess, onFail)
        nfc.readerMode(nfc.FLAG_READER_NFC_A, successcallback, onFail)
      } else {
        console.log('browser not support')
      }
    },
    executeBarcode: function (successcallback, userSpec, option, failcallback) {
      twoFuncTranslator(successcallback, failcallback).then(res => {
        function onBackKeyBarcode() {
          console.log('just barcode init')
        }
        function tempcallback(data) {

          res.successCallback(userSpec, data)
          if (window.__backkey_func === '') {
            document.removeEventListener("backbutton", onBackKeyBarcode, false)
            console.log('바코드 이벤트 삭제')
          } else {
            document.addEventListener("backbutton", window.__backkey_func , false)
          }

        }
        if (navigator.userAgent.indexOf('androidCordova') > 0 || navigator.userAgent.indexOf('iosCordova') > 0) {
          let defaultoption =
              {
                preferFrontCamera: false, // iOS and Android
                showFlipCameraButton: true, // iOS and Android
                showTorchButton: true, // iOS and Android
                torchOn: true, // Android, launch with the torch switched on (if available)
                saveHistory: true, // Android, save scan history (default false)
                prompt: "Place a barcode inside the scan area", // Android
                resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
                orientation: "landscape", // Android only (portrait|landscape), default unset so it rotates with the device
                disableAnimations: true, // iOS
                disableSuccessBeep: false, // iOS and Android
              }
          if (option) {
            Object.assign(defaultoption, option)
          }

          document.addEventListener("backbutton", onBackKeyBarcode , false)
          cordova.plugins.barcodeScanner.scan(
              tempcallback,
              res.failCallback, defaultoption,
          )
        } else {
          console.log('browser not support')
        }
      })
    },
    executeBioCertCheck: function (successcallback, userSpec, failcallback) {
      if (navigator.userAgent.indexOf('androidCordova') > 0 || navigator.userAgent.indexOf('iosCordova') > 0) {
        Fingerprint.isAvailable(successcallback, failcallback)
      } else {
        console.log('browser not support')
      }
    },
    executeBioCert: function (successcallback, userSpec, options, failcallback) {
      if (navigator.userAgent.indexOf('androidCordova') > 0 || navigator.userAgent.indexOf('iosCordova') > 0) {
        Fingerprint.show(options, onSuccess, failcallback)
      } else {
        console.log('browser not support')
      }
    },
    getGpsLocation: function (successcallback, userspec, failcallback) {
      twoFuncTranslator(successcallback, failcallback).then(res => {
        function tempcallback(data) {
          let tempData = {
            latitude: data.coords.latitude,
            longitude: data.coords.longitude
          }
          res.successCallback(userspec, tempData)
        }
        if (navigator.userAgent.indexOf('androidCordova') > 0 || navigator.userAgent.indexOf('iosCordova') > 0) {
          navigator.geolocation.getCurrentPosition(tempcallback, res.failCallback)
        } else {
          navigator.geolocation.getCurrentPosition(tempcallback, res.failCallback)
        }
      })
    },
    getNativeStorage: function (title, successcallback, failcallback) {
      if (navigator.userAgent.indexOf('androidCordova') > 0 || navigator.userAgent.indexOf('iosCordova') > 0) {
        NativeStorage.initWithSuiteName("suitename")
        NativeStorage.getItem(title, successcallback, failcallback)
      } else {
        console.log('browser not support')
      }
    },
    setNativeStorage: function (title, value) {
      NativeStorage.initWithSuiteName("suitename")
      NativeStorage.setItem(title, value)

    },
    fileDownload: function (successcallback, userSpec, options, failcallback) {

      if (navigator.userAgent.indexOf('androidCordova') > 0) {
        window.resolveLocalFileSystemURL(cordova.file.externalRootDirectory + 'Download/', function (dirEntry) {
          saveFile(dirEntry, options.file, options.fileName);
        }, onErrorLoadFs)
      } else if (navigator.userAgent.indexOf('iosCordova') > 0) {
        let cacheFilePath = cordova.file.cacheDirectory + options.fileName
        window.resolveLocalFileSystemURL(cordova.file.documentsDirectory, function (dirEntry) {
          saveFile(dirEntry, options.file, options.fileName);
        }, onErrorLoadFs)
      } else {
        console.log('browser not support')
      }

      function saveFile(dirEntry, fileData, fileName) {
        dirEntry.getFile(fileName, {create: true, exclusive: false}, function (fileEntry) {
          writeFile(fileEntry, fileData);
        }, onErrorLoadFs);
      }

      function onErrorLoadFs(err) {
        console.log(err, 'err')
      }

      function writeFile(fileEntry, dataObj) {
        fileEntry.createWriter(function (fileWriter) {
          fileWriter.onwriteend = successcallback(fileEntry)

          fileWriter.onerror = failcallback

          // If data object is not passed in,
          // create a new Blob instead.
          if (!dataObj) {
            dataObj = new Blob([dataObj], {type: 'text/plain'});
          }

          fileWriter.write(dataObj);
        });
      }
    },
    openDownloadFile: function (fileEntry, fileInfo) {
      if (navigator.userAgent.indexOf('androidCordova') > 0) {
        cordova.plugins.fileOpener2.open(fileEntry.nativeURL, fileInfo.file.type, {
          error: function (err) {
            console.log(err, 'err')
          },
          success: function (success) {
            console.log(success, 'success')
          }
        })
      } else if (navigator.userAgent.indexOf('iosCordova') > 0) {
        // console.log("ohmy...", fileEntry.toURl());
        console.log("ohmy...2", cordova.file.cacheDirectory);
        cordova.plugins.fileOpener2.open(fileEntry.nativeURL, fileInfo.file.type, {
          error: function (err) {
            console.log(err, 'err')
          },
          success: function (success) {
            console.log(success, 'success')
          },
          position: [0, 0]
        })
        // console.log('testing now')
      } else {
        console.log('browser not support')
      }
    },
    inAppBrowser: function (url, type) {
      if (navigator.userAgent.indexOf('androidCordova') > 0 || navigator.userAgent.indexOf('iosCordova') > 0) {
        cordova.InAppBrowser.open(url, type ? type : '_system')
      } else {
        console.log('browser not support')
      }
    },
    // GET 방식 API호출로 파일 다운로드
    getFileDown: function (url, fileName, options, successCallback, failCallback) {
      if (navigator.userAgent.indexOf('androidCordova') > 0 || navigator.userAgent.indexOf('iosCordova') > 0) {
        let Downloader = cordova.plugins.xbuilderPlugin;

        let downloadSuccessCallback = successCallback

        let downloadErrorCallback = failCallback

        let defaultoption =
            {
              title: 'Downloading File - ' + fileName, // Download Notification Title
              url: url, // File Url
              path: fileName, // The File Name with extension
              description: 'file is downloading', // Download description Notification String
              visible: true, // This download is visible and shows in the notifications while in progress and after completion.
              folder: "Download", // Folder to save the downloaded file, if not exist it will be created
              "x-auth-token": '',
              "x-apiversion": '',
              "x-app": ''
            }
        if (options) {
          Object.assign(defaultoption, options)
        }
        // console.log(defaultoption, 'option check')

        Downloader.downloader(defaultoption, downloadSuccessCallback, downloadErrorCallback);
      } else {
        console.log('browser not support')
      }
    },
    // mocean 로그인 id 가져오기
    getUserId: function () {
      NativeStorage.initWithSuiteName("suitename")
      console.log('오긴와용')
      
      return new Promise((resolve, reject) => {
        function __m__successCallback(data) {          
          resolve(data)          
        }        
        

        function __m__failCallback(err) {
          reject(err)
        }

        NativeStorage.getItem('mssoUserId', __m__successCallback, __m__failCallback)
       

      })
    },
    // mocean 로그인 id 가져오기 터치원용
    getUserInfo: function (successcallback, userSpecific) {
      oneFuncTranslator(successcallback).then(res => {
        if (navigator.userAgent.indexOf('androidCordova') > 0) {

          let resultData = ''
          let phoneNum = ''

          function tempcallback(data) {
            phoneNum = JSON.parse(data).PhoneNum
            console.log(data,'넘버')
            NativeStorage.getItem('mssoUserId', tempcallback2, this.failcallback)
          }
          function tempcallback2(id) {
            resultData = '{"UserId": "' + id + '", "phoneNum":"' + phoneNum + '"}'
            res.callback(userSpecific, resultData)
          }
          cordova.plugins.xbuilderPlugin.getPhoneNum(tempcallback)
        } else if (navigator.userAgent.indexOf('iosCordova') > 0) {
          NativeStorage.initWithSuiteName("suitename")
          let resultData = ''
          function tempcallback(id) {
            resultData = '{"UserId": "' + id + '", "phoneNum":"NONE"}'
            res.callback(userSpecific, resultData)
          }
          NativeStorage.getItem('mssoUserId', tempcallback, this.failcallback)
        }
      })
    },
    executeExitWebBrowser: function () {
      if (navigator.userAgent.indexOf('iosCordova') > 0) {
        webview.Hide()
      } else if (navigator.userAgent.indexOf('androidCordova') > 0) {
        webview.ExitApp()
      } else {
        console.log('browser not support')
      }

    },
    getDeviceSpec: function(callbackFunc, userSpecific){
      oneFuncTranslator(callbackFunc).then(res => {
        if (navigator.userAgent.indexOf('iosCordova') > 0 || navigator.userAgent.indexOf('androidCordova') > 0) {
          let deviceInfo = {
            MODEL_NAME: device.model,
            OS_TYPE: device.platform,
            DEVICE_ID: device.uuid,
            SDK_VERSION: device.sdkVersion,
            OS_VERSION: device.version,
          }
          res.callback(userSpecific, deviceInfo)
        } else {
          console.log('browser not support')
        }
      })
    },
    executeBackKeyEvent: function(CBBackKey, userSpecific){
      if (navigator.userAgent.indexOf('androidCordova') > 0) {
        oneFuncTranslator(CBBackKey).then(res => {
          function tempcallback() {
            res.callback(userSpecific)
          }
          window.__backkey_func = tempcallback
          document.addEventListener("backbutton", window.__backkey_func , false)
          // tempcallback()
        })
      } else {
        console.log('ios, browser not support')
      }
    },
    setBackKeyEvent: function(backkeyMode){
      if (navigator.userAgent.indexOf('androidCordova') > 0) {
        if (backkeyMode === '0') {
          document.removeEventListener("backbutton", window.__backkey_func, false)
        }
      } else {
        console.log('ios, browser not support')
      }
    },
    // dataObj {"title" : "타이틀", "filePath" : "http://aaa.com/filedownloadurl..."}
    showSecureDoc : function (filePath , exitCallBackFunction) {
      let dataObj = {}
      var __showdoc = function (watermark) {
        if (navigator.userAgent.indexOf('androidCordova') > 0 || navigator.userAgent.indexOf('iosCordova') > 0) {
          dataObj.watermark = watermark
          dataObj.filePath = filePath
          dataObj.target = '_blank'
          cordova.plugins.xbuilderPlugin.showSecureDoc(dataObj, exitCallBackFunction)
        } else {
          console.log('browser not support')
        }
      }

      NativeStorage.getItem('__watermark', (data) =>
      {
        __showdoc(data);
      }, (err) => {
        __showdoc("");
      });
    },
    showImageView: function (dataObj , exitCallBackFunction)  {
      var __proto = this;

      var __showdoc = function (watermark) {
        var params = "";
        var watermarkText = watermark;
        var __exitCall ;
        var __inApp ;
        var __options = "location=yes,hidden=no,footer=no,fullscreen=yes,hideurlbar=yes,zoom=false,hidenavigationbuttons=yes";
        var __url = "";
        if(dataObj['filePath']) {


          if(typeof exitCallBackFunction === "string") {
            __exitCall = eval(exitCallBackFunction);
          } else {
            __exitCall = exitCallBackFunction;
          }

          if (watermark != "") dataObj['watermark'] = watermark;

          __url = "https://mocean.hd-hvs.com/mlauncher/external/moceanImgView.html?d=" + encodeURIComponent(JSON.stringify(dataObj));



          if (navigator.userAgent.indexOf('androidCordova') > 0 || navigator.userAgent.indexOf('iosCordova') > 0) {
            __inApp = cordova.InAppBrowser.open(__url, '_blank' , __options);

            if(typeof __exitCall === 'function') {
              __inApp.addEventListener('exit', __exitCall);
            }
          } else {
            __inApp= window.open(__url, '_blank' , __options)
          }



        }
      }


      NativeStorage.getItem('__watermark', (data) =>
      {
        __showdoc(data);
      }, (err) => {
        __showdoc("");
      });
    },

    generateUUID : function () { // Public Domain/MIT
      var d = new Date().getTime();//Timestamp
      var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16;//random number between 0 and 16
        if(d > 0){//Use timestamp until depleted
          r = (d + r)%16 | 0;
          d = Math.floor(d/16);
        } else {//Use microseconds since page-load if supported
          r = (d2 + r)%16 | 0;
          d2 = Math.floor(d2/16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
    },
    getNetworkInfo: function(callbackFunc, userSpecific){
      if (navigator.userAgent.indexOf('androidCordova') > 0) {
          oneFuncTranslator(callbackFunc).then(res => {

            function tempcallback(data) {
              res.callback(userSpecific, data)
            }
            cordova.plugins.xbuilderPlugin.getNetworkInfo(tempcallback)
          })
      } else {
        console.log('ios, browser not support')
      }
    },
    getMDMInfo: function(successcallback, userSpecific){
      if (navigator.userAgent.indexOf('androidCordova') > 0) {
        oneFuncTranslator(successcallback).then(res => {
          function tempcallback(data) {
            res.callback(userSpecific, data)
          }
          cordova.plugins.xbuilderPlugin.getMDMInfo({}, tempcallback)
        })

      } else {
        console.log('ios, browser not support')
      }
    },
    executeImageEditor: function(successcallback,  userSpecific, imagePath, flagDeleteOrgFile){
      if (navigator.userAgent.indexOf('androidCordova') > 0) {
        oneFuncTranslator(successcallback).then(res => {
          function tempcallback(data) {
            res.callback(userSpecific, data)
          }
          cordova.plugins.xbuilderPlugin.executeImageEditor({ path: imagePath }, tempcallback)
        })
      } else {
        console.log('ios, browser not support')
      }
    },
    executeSecurityCamera: function(successCallback, userSpec, userId) {
      // (new Function('return ' + CBBackKey))()
      if (navigator.userAgent.indexOf('iosCordova') > 0) {
        console.log('executeSecurityCamera not support')
      } else if (navigator.userAgent.indexOf('androidCordova') > 0) {
        oneFuncTranslator(successCallback).then(res => {
          function tempcallback(data) {
            res.callback(userSpec, data)
          }
          cordova.plugins.xbuilderPlugin.executeSecurityCamera(userId, tempcallback, this.failCallback)
        })

      } else {
        console.log('executeSecurityCamera not support')
      }
    },
    getFileList: function(successCallback, userSpec, path) {
      // (new Function('return ' + CBBackKey))()
      if (navigator.userAgent.indexOf('iosCordova') > 0) {
        console.log('getFileList not support')
      } else if (navigator.userAgent.indexOf('androidCordova') > 0) {
        oneFuncTranslator(successCallback).then(res => {
          function tempcallback(data) {
            res.callback(userSpec, data)
          }
          cordova.plugins.xbuilderPlugin.getFileList(path, tempcallback, this.failCallback)
        })
      } else {
        console.log('getFileList not support')
      }
    },
    executeFileUpload: function(successCallback, userSpec, fileList, path, header) {
      const files = JSON.parse(fileList)
      let headerprop = {}
      if (header !== null && header !== undefined) {
        headerprop = header
      }
      oneFuncTranslator(successCallback).then(res => {
        function tempcallback(data) {
          res.callback(userSpec, data)
        }

        const size = files.length
        let count = 0

        for (const key in files) {
          count = count + 1
          const filePath = files[key]
          const temp = filePath.split('/')
          const fileName = temp[temp.length - 1]
          var options = new FileUploadOptions()
          options.fileKey = 'file'
          options.headers = headerprop
          options.fileName = fileName
          options.httpMethod = 'POST'
          options.mimeType = 'multipart/form-data'
          var ft = new FileTransfer()
          ft.upload(filePath,path,(res) => {
            if (count == size)
              console.log(res)
            console.log(size)
            tempcallback(res)
          },this.failCallback, options, true)
        }
      })
    },
    executeFileDataUpload: function(successCallback, userSpec, fileList, path, options) {
      const files = JSON.parse(fileList)
      let headerprop = {}
      let bodyData = {}
      if (options.header !== null && options.header !== undefined) {
        headerprop = options.header
      }
      if (options.params !== null && options.params !== undefined) {
        bodyData = options.params
      }
      oneFuncTranslator(successCallback).then(res => {
        function tempcallback(data) {
          res.callback(userSpec, data)
        }

        const size = files.length
        let count = 0

        for (const key in files) {
          count = count + 1
          const filePath = files[key]
          const temp = filePath.split('/')
          const fileName = temp[temp.length - 1]
          const options = {
            headers: headerprop,
            fileName: fileName,
            mimeType: 'multipart/form-data',
            httpMethod: 'POST',
            params: bodyData
          }
          var ft = new FileTransfer()
          ft.upload(filePath,path,(res) => {
            if (count == size)
              console.log(res)
            console.log(size)
            tempcallback(res)
          },this.failCallback, options, true)
        }
      })
    },
// executeFileUpload: function(successCallback, failCallback) {
//     // (new Function('return ' + CBBackKey))()
//     if (navigator.userAgent.indexOf('iosCordova') > 0) {
//         console.log('executeSecurityCamera not support')
//     } else if (navigator.userAgent.indexOf('androidCordova') > 0) {
//         // cordova.plugins.xbuilderPlugin.executeFileUpload(successCallback, failCallback)
//         const options = {
//             headers: {
//                 'X-Auth-Token': '8021ca7a-1729-4e7b-a680-56b1b978f162',
//                 'X-APIVERSION': '2.0.0',
//                 'Connection': 'Keep-Alive'
//             },
//             fileName: 'IMG_20240411_045619.jpg',
//             mimeType: 'image/jpg',
//             httpMethod: 'POST'
//         }
//         //'/storage/emulated/0/Pictures/IMG_20240411_045619.jpg'
//         window.FileTransfer.prototype.upload('/sdcard/DCIM/Camera/20240418_164810.jpg','http://10.92.103.11:49028/hiway/file',successCallback,failCallback, options, true)
//     } else {
//         console.log('executeSecurityCamera not support')
//     }
// },
    executeMenu: function(successCallback,userSpec, appName, token) {
      this.getMenuInfo( (userspec, result) => {
        if (result.INSTALLED && result.IS_LATEST_VERSION) {
          // 설치가 이미 되어있는 앱인지 다시 한번 체크
          alert('해당 앱이 이미 설치되어있습니다.')
          console.log('해당 앱이 이미 설치되어있음.')
        } else {
          let file = ''
          let fileId = ''
          let apiUrl = ''
          file = result.install_files.android[0]
          fileId = result.install_files.android[0].fileId
          if (__m_ev === 'dev') {
            apiUrl = 'https://mocean.hd-hvs.com/mocean/utils/file/download/' +fileId
          } else {
            apiUrl = 'https://mocean.hd-hvs.com/mocean/utils/file/download/' +fileId
          }
          let options = {
            "x-auth-token": token,
            "x-apiversion": '1.0.0',
            "x-app": 'TTX01'
          }
          //설치 파일 다운로드
          this.getFileDown(apiUrl, file.fileName, options, downSuc, downFail)
          function downSuc(suc) {
            alert('확인을 누르시면 다운로드가 시작됩니다. 상단 알림탭을 확인하세요.')
          }
          function downFail(msg) {
            alert('파일다운로드에 실패하였습니다. msg: ' + msg)
          }
          // cordova.InAppBrowser.open(result.app_url, '_blank')
        }
        oneFuncTranslator(successCallback).then(res => {
            res.callback(userSpec, result)
        })
      }, userSpec, appName, token)
    },
    getMenuInfo: function(successCallback, userSpec, appName, token) {
      if (navigator.userAgent.indexOf('iosCordova') > 0) {
        console.log('getMenuInfo ios 있음')
      } else if (navigator.userAgent.indexOf('androidCordova') > 0) {
        oneFuncTranslator(successCallback).then(res => {
          function tempcallback(data) {
            res.callback(userSpec, data)
          }
          console.log('타긴탐')
          cordova.plugins.xbuilderPlugin.getMenuInfo({ name: appName, token: token}, tempcallback, this.failCallback)
        })
      }
    },
    executeRecognizeSpeech: function(successCallback, userSpec) {
      if (navigator.userAgent.indexOf('iosCordova') > 0) {
        console.log('executeRecognizeSpeech ios 있음')
      } else if (navigator.userAgent.indexOf('androidCordova') > 0) {
        oneFuncTranslator(successCallback).then(res => {
          function tempcallback(data) {
            res.callback(userSpec, data)
          }
          cordova.plugins.xbuilderPlugin.executeRecognizeSpeech(tempcallback, this.failCallback)
        })
      } else {
        console.log('executeRecognizeSpeech not support')
      }
    },
    executeApplication: function (data) {
      var dataObj = JSON.parse(data)
      var sApp = startApp.set({
        "component": [dataObj.PACKAGE_NM,dataObj.PACKAGE_MAIN],
        "flags": ['FLAG_ACTIVITY_NEW_TASK'],
      }, dataObj.PARAM);

      sApp.start(function(compete) { // if receiver is registered
        console.log('compete', compete);
      }, function(error) {
        alert('package name과 activity name을 확인해주세요')
        console.error('error', error);
      }, function(result, requestCode, resultCode) { // result message
        console.log("<div>" + JSON.stringify(result) + ", " + requestCode + ", " + resultCode + "</div>");
      });
    },
    getCheckSession: function(successCallback, userSpec) {
      if (navigator.userAgent.indexOf('iosCordova') > 0) {
        console.log('executeRecognizeSpeech not support')
      } else if (navigator.userAgent.indexOf('androidCordova') > 0) {
        oneFuncTranslator(successCallback).then(res => {
          function tempcallback(data) {
            res.callback(userSpec, data)
          }
          cordova.plugins.xbuilderPlugin.getCheckSession(tempcallback, this.failCallback)
        })
      } else {
        console.log('executeRecognizeSpeech not support')
      }

    },
    executeExternalBrowser: function(url) {
      cordova.InAppBrowser.open(url, '_blank')
      // cordova.InAppBrowser.open(url, '_system') // 외부
      // startApp.set({ /* params */
      //     "action": "ACTION_VIEW",
      //     "uri": "http://www.naver.com"
      // }).start();
      // if (navigator.userAgent.indexOf('iosCordova') > 0) {
      //     console.log('executeRecognizeSpeech not support')
      // } else if (navigator.userAgent.indexOf('androidCordova') > 0) {
      //     cordova.plugins.xbuilderPlugin.executeExternalBrowser(url, successCallback, failCallback)
      // } else {
      //     console.log('executeRecognizeSpeech not support')
      // }
    },
    executeVideoPlayer: function (url) {
      cordova.InAppBrowser.open(url, '_blank')
      // if (navigator.userAgent.indexOf('iosCordova') > 0) {
      //     console.log('executeRecognizeSpeech not support')
      // } else if (navigator.userAgent.indexOf('androidCordova') > 0) {
      // startApp.set({ /* params */
      //     "action": "ACTION_VIEW",
      //     "flags": ['FLAG_ACTIVITY_NEW_TASK','FLAG_ACTIVITY_NO_USER_ACTION'],
      //     "uri": "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
      //     "type": "video/*"
      // }).start();
      // } else {
      //     console.log('executeRecognizeSpeech not support')
      // }
    },
    getMockLocationInfo: function (successCallback, userSpec) {
      if (navigator.userAgent.indexOf('iosCordova') > 0) {
        console.log('getMockLocationInfo not support')
      } else if (navigator.userAgent.indexOf('androidCordova') > 0) {
        oneFuncTranslator(successCallback).then(res => {
          function tempcallback(data) {
            res.callback(userSpec, data)
          }
          cordova.plugins.xbuilderPlugin.getMockLocationInfo(tempcallback, this.failCallback)
        })
      } else {
        console.log('getMockLocationInfo not support')
      }
    },
    executeSignPad: function (successCallback, userSpec) {
      const userId = this.getUserId()
      console.log(userId)
      if (navigator.userAgent.indexOf('iosCordova') > 0) {
        console.log('executeSignPad 있음')
      } else if (navigator.userAgent.indexOf('androidCordova') > 0) {
        oneFuncTranslator(successCallback).then(res => {
          function tempcallback(data) {
            res.callback(userSpec, data)
          }
          cordova.plugins.xbuilderPlugin.executeSignpad(userId, tempcallback, this.failCallback)
        })
      } else {
        console.log('executeRecognizeSpeech not support')
      }
    },
    executeWebHistoryClear: function (successCallback, userSpec) {
      if (navigator.userAgent.indexOf('iosCordova') > 0) {
        oneFuncTranslator(successCallback).then(res => {
          function tempcallback(data) {
            res.callback(userSpec, data)
          }
          window.WkCacheClear({domain:  window.location.hostname, delete: ['assets']}, tempcallback);

        })
      } else if (navigator.userAgent.indexOf('androidCordova') > 0) {
        oneFuncTranslator(successCallback).then(res => {
          function tempcallback(data) {
            res.callback(userSpec, data)
          }
          window.CacheClear(tempcallback);
        })
      } else {
        console.log('executeWebHistoryClear not support')
      }
    },
    executeProgressDialogStart: function (successCallback, titleparam, msgparam) {
      if (navigator.userAgent.indexOf('iosCordova') > 0) {
        oneFuncTranslator(successCallback).then(res => {
          let options = {
            title: '',
            msg: ''
          }
          if (titleparam) {
            options.title = titleparam
          }
          if (msgparam) {
            options.msg = msgparam
          }
          cordova.plugins.xbuilderPlugin.executeProgressDialogStart(options, res.callback)
        })
      } else if (navigator.userAgent.indexOf('androidCordova') > 0) {
        oneFuncTranslator(successCallback).then(res => {
          let options = {
            title: '',
            msg: ''
          }
          if (titleparam) {
            options.title = titleparam
          }
          if (msgparam) {
            options.msg = msgparam
          }
          cordova.plugins.xbuilderPlugin.executeProgressDialogStart(options, res.callback)
        })
      } else {
        console.log('getMockLocationInfo not support')
      }
    },
    executeProgressDialogStop: function (successCallback) {
      if (navigator.userAgent.indexOf('iosCordova') > 0) {
        oneFuncTranslator(successCallback).then(res => {
          cordova.plugins.xbuilderPlugin.executeProgressDialogStop(res.callback)
        })
      } else if (navigator.userAgent.indexOf('androidCordova') > 0) {
        oneFuncTranslator(successCallback).then(res => {
          cordova.plugins.xbuilderPlugin.executeProgressDialogStop(res.callback)
        })
      } else {
        console.log('getMockLocationInfo not support')
      }
    },
    getUserSession: function () {
      NativeStorage.initWithSuiteName("suitename")
      return new Promise((resolve, reject) => {
        function __m__successCallback(data) {
          resolve(data)
        }

        function __m__failCallback(err) {
          reject(err)
        }

        NativeStorage.getItem('usersession', __m__successCallback, __m__failCallback)


      })
    },
    executePreventCapture: function (successCallback, mode, apiobj) {
      if (navigator.userAgent.indexOf('iosCordova') > 0) {
        this.getUserSession().then(res => {
          if (apiobj !== null && apiobj !== undefined) {
            apiobj.capture_user_id = res.userId
            apiobj.capture_user_name = res.userName
            apiobj.app_code = res.appCode
            apiobj.app_name = res.appName
            let xhr = new XMLHttpRequest()
            let url = ''
            if (__m_ev === 'dev') {
              url = 'https://mocean.hd-hvs.com/mocean/applauncher/capturelog'
            } else {
              url = 'https://mocean.hd-hvs.com/mocean/applauncher/capturelog'
            }
            xhr.open('POST', url)
            xhr.setRequestHeader('X-APIVERSION', '1.0.0')
            xhr.setRequestHeader('X-APP', 'TTX01')
            xhr.setRequestHeader("content-type", "application/json; charset=UTF-8");
            xhr.send(JSON.stringify(apiobj))
          }
          oneFuncTranslator(successCallback).then(res => {
            if (mode) {
              document.addEventListener("screenshot", res.callback, false)
            } else {
              document.removeEventListener("screenshot", res.callback, false)
            }
          })
        })
      } else if (navigator.userAgent.indexOf('androidCordova') > 0) {
          oneFuncTranslator(successCallback).then(res => {
            if (mode) {
              window.plugins.preventscreenshot.disable(res.callback)
            } else {
              window.plugins.preventscreenshot.enable(res.callback)
            }
          })
      } else {
        console.log('executeWebHistoryClear not support')
      }
    },
    getConvertImageToBase64: function (successCallback, path) {
      if (navigator.userAgent.indexOf('iosCordova') > 0) {
        oneFuncTranslator(successCallback).then(res => {
          window.resolveLocalFileSystemURL(path, gotFile, fail);

          function fail(e) {
            alert('Cannot found requested file');
          }

          function gotFile(fileEntry) {
            fileEntry.file(function(file) {
              var reader = new FileReader();
              reader.onloadend = function(e) {
                var content = this.result;
                res.callback(content);
              };
              // The most important point, use the readAsDatURL Method from the file plugin
              reader.readAsDataURL(file);
            });
          }
        })
      } else if (navigator.userAgent.indexOf('androidCordova') > 0) {
        oneFuncTranslator(successCallback).then(res => {
          window.resolveLocalFileSystemURL(path, gotFile, fail);

          function fail(e) {
            alert('Cannot found requested file');
          }

          function gotFile(fileEntry) {
            fileEntry.file(function(file) {
              var reader = new FileReader();
              reader.onloadend = function(e) {
                var content = this.result;
                res.callback(content);
              };
              // The most important point, use the readAsDatURL Method from the file plugin
              reader.readAsDataURL(file);
            });
          }
        })
      } else {
        console.log('getConvertImageToBase64 not support')
      }
    },
    getSessionToken: function () {
      NativeStorage.initWithSuiteName("suitename")

      return new Promise((resolve, reject) => {
        function __m__successCallback(data) {
          resolve(data)
        }

        function __m__failCallback(err) {
          reject(err)
        }

        NativeStorage.getItem('__sessiontoken', __m__successCallback, __m__failCallback)
      })
    },
    executeRecordingSpeech: function (successCallback, failCallback, option) {
      if (navigator.userAgent.indexOf('iosCordova') > 0 || navigator.userAgent.indexOf('androidCordova') > 0) {
        twoFuncTranslator(successCallback, failCallback).then(res => {
          navigator.device.capture.captureAudio(
              res.callback, res.failCallback,  option
          );
        })
      } else {
      }
    },
    executeMediaFile: function (filePath) {
      if (navigator.userAgent.indexOf('iosCordova') > 0 || navigator.userAgent.indexOf('androidCordova') > 0) {
        return new Media(
            filePath,
            function () {
              console.log("오디오 재생 완료");
            },
            function (err) {
              console.error("오디오 재생 실패", err);
            }
        );
      } else {
      }
    },
    postMessage: function (messageObj) {
      webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(messageObj, '*'))
    },
    failCallback: function(msg) {
      alert('fail callback message: ' + msg)

      console.log("Sharing failed with message: " + JSON.stringify(msg));
    },
  }


